export const ssrConfig = () => (Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined);
